import * as pis from 'validation-br/dist/pisPasep';

/**
 * Removes anything that is nota numeric value returning only the numbers on the string
 * @param value
 */
export const removeNonNumericValues = (value : string): string  => {
  return value.replace(/\D/gm,'');
};

/**
 * Removes all punctuation, allowing only alphanumeric values
 * @param value
 */
export const removePunctuation = (value : string): string => {
  return value.replace(/[^a-zA-Z0-9]+/gm,'');
};

export const cpfNormalizers = {
  getFirst7Digits : (cpf: string) : string => {
    return removeNonNumericValues(cpf || '').slice(0,7);
  },
  getLast4Digits : (cpf: string) : string => {
    return removeNonNumericValues(cpf || '').slice(-4);
  },
};

export const pisPasepNormalizers = {
  mask : (pisPasepNumber : string) => {
    if(pis.validate(pisPasepNumber) && pisPasepNumber.length >= 11)
      return pis.mask(pisPasepNumber);

    return pisPasepNumber;
  },
};